import { useEffect, useState } from "react";

import TopicRuleList from "./TopicRuleList";
import { Dialog } from "primereact/dialog";

import { Card } from "primereact/card";
import TopicRuleCreate from "./TopicRuleCreate";
import { ITopicRule } from "./TopicRule.model";
import { topicRuleService } from "../../service/TopicRule/topicRule.service";

const TopicRule = () => {
  const [topicRuleDialog, setTopicRuleDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ITopicRule[]>([]);
  const openNew = () => {
    setTopicRuleDialog(true);
  };

  const hideDialog = () => {
    setTopicRuleDialog(false);
  };

  useEffect(() => {
    loadTopicRules();
  }, []);

  const loadTopicRules = async () => {
    setLoading(true);
    const res = await topicRuleService.getAll();
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Dialog
          visible={topicRuleDialog}
          header={"Topic Rule Details"}
          modal
          onHide={() => hideDialog()}
          style={{ width: "50vw" }}>
          <TopicRuleCreate
            setTopicRuleDialog={setTopicRuleDialog}
            loadTopicRules={loadTopicRules}
          />
        </Dialog>
        <TopicRuleList
          openNew={openNew}
          loading={loading}
          data={data}
          loadTopicRules={loadTopicRules}
        />
      </Card>
    </>
  );
};

export default TopicRule;
